export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8105.75207c0c.jpg";